export default {"src":"/_next/static/media/favorite.40835c71.svg","height":32,"width":37};